import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const WhyUs = () => {
  const { t } = useTranslation();

  const cards = [
    {
      imageSrc: "/images/team-trained.jpg",
      title: t("whyUs.card1Title"),
      description: t("whyUs.card1Description"),
    },
    {
      imageSrc: "/images/team2.jpg",
      title: t("whyUs.card2Title"),
      description: t("whyUs.card2Description"),
    },
    {
      imageSrc: "/images/Simax koli.jpg",
      title: t("whyUs.card3Title"),
      description: t("whyUs.card3Description"),
    },
  ];

  return (
    <section className="px-5 max-w-[1290px] w-full mx-auto mt-32">
      <div className="mx-auto">
        <p className="font-bold text-[16px] leading-[20.8px] text-[#4F4F4F]">
          {t("whyUs.whyUs")}
        </p>
        <div className="flex flex-col lg:w-[40%]">
          <h2 className="text-[27.65px] leading-[33.18px] font-extrabold text-[#111111] mb-4 mt-10">
            {t("whyUs.title")}
          </h2>
          <p className="text-[#3D3D3D] mb-6 text-[16px] leading-[20.8px] font-normal">
            {t("whyUs.description")}
          </p>
        </div>
        <Link
          to="/contactus"
          className="flex w-[120px] items-center justify-center gap-2 p-[10px_24px] rounded-[12px] bg-[#FEEED6] text-[#F67E20] hover:bg-[#F67E20] hover:text-[#FEEED6] font-medium transition-all duration-300 ease-in-out"
        >
          {t("nav.contact")} <i className="fas fa-arrow-right ml-2"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {cards.map((card, index) => (
          <div key={index} className="flex flex-col items-start mt-10">
            <img
              src={card.imageSrc}
              alt={card.title}
              className="h-[204px] w-full object-cover rounded-lg"
              loading="lazy"
            />
            <h3 className="text-[#111111] text-[19.2px] font-bold leading-[24.96px] mb-4 mt-8">
              {card.title}
            </h3>
            <p className="text-[#3D3D3D] text-[16px] font-[400] leading-[20.8px]">
              {card.description}
            </p>
          </div>
        ))}
      </div>
      <span className="w-full block h-[1px] bg-[#DCDCDC] mt-32 mb-20"></span>
    </section>
  );
};

export default WhyUs;
